import { render, staticRenderFns } from "./SupplierWorkspace.vue?vue&type=template&id=f319d7e0&scoped=true"
import script from "./SupplierWorkspace.vue?vue&type=script&lang=js"
export * from "./SupplierWorkspace.vue?vue&type=script&lang=js"
import style0 from "./SupplierWorkspace.vue?vue&type=style&index=0&id=f319d7e0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f319d7e0",
  null
  
)

export default component.exports